var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:("brand-theme-" + _vm.theme)},[_c('span',{staticClass:"brand"},[_vm._v(_vm._s(_vm.$t('gallery-main:brand-name')))]),_vm._v("  "),_c('span',{staticClass:"product"},[_vm._v(_vm._s(_vm.$t('gallery-main:application-name')))])])}
var staticRenderFns = []

export { render, staticRenderFns }